module.exports = __webpack_public_path__ + "img/information@2x.730ca4e8.png";